export const TuttiFruttiMsg = ({ msg }) => {
  return (
    <>
      <div className="overall-msg">
        <div id="tutti-msg">{msg}</div>
      </div>
    </>
  )
}
